// extracted by mini-css-extract-plugin
module.exports = {"root":"Footer_root__WcJyK","inner":"Footer_inner__18MQA"};